<script setup lang="ts">
  import { NewsFullItem } from '@/features/news'

  definePage({
    meta: { layout: 'baseNew' },
  })
</script>

<template>
  <NewsFullItem />
</template>
